import RelativesListContainer2 from './relativesListContainer';

export default RelativesListContainer2;
